import React, { useEffect, useState } from "react";
import { DataGrid, gridClasses, GridMoreVertIcon } from "@mui/x-data-grid";
import dayjs from "dayjs";
import { IconButton, Popover, MenuItem, Checkbox } from "@mui/material";
import DeleteModal from "../../components/Model/DeleteModal";
import { HttpService } from "../../service/HttpService";
import FullScreenLoader from "../../components/Loader/FullScreenLoader";
import { components } from "react-select";
import { TbFilterEdit } from "react-icons/tb";
import { Button } from "@mui/material";
import DateTimeModal from "../Schedule/ScheduleListAdd/DateTimeModal";
import { GoTrash } from "react-icons/go";
import { toast } from "react-toastify";

const Cluster = () => {
  const dateFilterData = JSON.parse(localStorage.getItem("clusterDateFilter"));
  const [open, setOpen] = useState(false);
  const [isAdd, setIsAdd] = useState(false);
  const [clusters, setClusters] = useState([]);
  const [editData, setEditData] = useState({});
  const [loading, setLoading] = useState(false);
  const [pageSize, setPageSize] = useState(15);
  const [rowCount, setRowCount] = useState(0);
  const [searchData, setSearchData] = useState([]);
  const [page, setPage] = useState(0);
  const [openDelete, setOpenDelete] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [dataId, setDataId] = useState();
  const [openDateModal, setOpenDateModal] = useState(false);
  const [startDate, setStartDate] = useState(
    dateFilterData?.startDate || dayjs().subtract(6, "day").format("MM-DD-YYYY")
  );
  const [endDate, setEndDate] = useState(
    dateFilterData?.endDate || dayjs().format("MM-DD-YYYY")
  );
  const [selectedRadio, setSelectedRadio] = useState(
    dateFilterData?.selectedRadio || "week"
  );
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [selectedId, setSelectedId] = useState([]);
  const [allIds, setAllIds] = useState(0);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const httpService = new HttpService();

  const fetchClusters = async () => {
    setLoading(true);
    try {
      const res = await httpService.get(
        `motherplant/clusters?page=${
          page + 1
        }&pageSize=${pageSize}&start_date=${startDate}&end_date=${endDate}&search=${searchData}`
      );
      if (res?.data?.data?.length > 0) {
        setClusters(res?.data?.data || []);
        setRowCount(res?.data?.pagination?.total || 0);
      } else {
        setClusters([]);
        setRowCount(0);
      }
    } catch (e) {
      setClusters([]);
      setRowCount(0);
    }
    setLoading(false);
  };

  const updateStatus = async (id, checked) => {
    const httpService = new HttpService();
    try {
      await httpService.put(`motherplant/cluster/${id}`, {
        status: checked ? true : false,
      });
      fetchClusters();
    } catch (err) {}
  };

  useEffect(() => {
    fetchClusters();
  }, [page, pageSize, searchData]);

  useEffect(() => {
    const dateFilterData = JSON.parse(
      localStorage.getItem("clusterDateFilter")
    );
    if (dateFilterData && dateFilterData?.selectedRadio) {
      setStartDate(dateFilterData?.startDate);
      setEndDate(dateFilterData?.endDate);
      setSelectedRadio(dateFilterData?.selectedRadio);
    } else {
      const clusterDateFilter = {
        startDate: dayjs().subtract(6, "day").format("MM-DD-YYYY"),
        endDate: dayjs().format("MM-DD-YYYY"),
        selectedRadio: "week",
      };
      setStartDate(clusterDateFilter?.startDate);
      setEndDate(clusterDateFilter?.endDate);
      setSelectedRadio(clusterDateFilter?.selectedRadio);
      localStorage.setItem(
        "clusterDateFilter",
        JSON.stringify(clusterDateFilter)
      );
    }
  }, []);

  const columns = [
    // {
    //   field: "action",
    //   headerName: "Actions",
    //   headerAlign: "center",
    //   align: "center",
    //   width: 100,
    //   disableColumnMenu: true,
    //   renderCell: (params) => (
    //     <>
    //       <div className="action_icon-weap">
    //         <IconButton
    //           onClick={(e) => {
    //             handleMenuClick(e), setDataId(params.row.id);
    //           }}
    //         >
    //           <GridMoreVertIcon />
    //         </IconButton>
    //       </div>
    //       {anchorEl && dataId === params?.row?.id && (
    //         <Popover
    //           className="popup-menu"
    //           key={dataId}
    //           open={Boolean(anchorEl)}
    //           anchorEl={anchorEl}
    //           onClose={handleCloseMenu}
    //           anchorOrigin={{
    //             vertical: "bottom",
    //             horizontal: "right",
    //           }}
    //           transformOrigin={{
    //             vertical: "top",
    //             horizontal: "right",
    //           }}
    //         >
    //           <MenuItem
    //                 onClick={() => {
    //                   viewPage(dataId);
    //                 }}
    //                 className="menu-list-items"
    //               >
    //                 <div className="menu-list-items-text">View</div>
    //                 <HiOutlineEye style={{ cursor: "pointer" }} />
    //               </MenuItem>
    //               <MenuItem
    //                 onClick={() => {
    //                   // console.log("params", params.row.id);
    //                   setOpenModel(true);
    //                   setIsAdd(false);
    //                   setInventory_Id(dataId);
    //                   handleCloseMenu();
    //                 }}
    //                 className="menu-list-items"
    //               >
    //                 <div className="menu-list-items-text">Edit</div>
    //                 <CiEdit style={{ cursor: "pointer" }} />
    //               </MenuItem>
    //           <MenuItem
    //             onClick={() => {
    //               setOpenDelete(true);
    //               handleCloseMenu();
    //             }}
    //             className="menu-list-items"
    //           >
    //             <div className="menu-list-items-text">Delete</div>
    //             <GoTrash style={{ cursor: "pointer" }} />
    //           </MenuItem>
    //         </Popover>
    //       )}
    //     </>
    //   ),
    //   sortable: false,
    // },
    // {
    //   field: "select_All",
    //   headerName: "Select All",
    //   minWidth: 150,
    //   align: "center",
    //   sortable: false,
    //   disableColumnMenu: true,
    //   renderCell: (params) => {
    //     return (
    //       <Checkbox
    //         value="Checked"
    //         checked={
    //           isAllSelected ? true : isIdSelected(params.row.id) ? true : false
    //         }
    //         onChange={() => toggleId(params.row.id)}
    //       />
    //     );
    //   },
    //   headerCheckboxSelection: true,
    //   renderHeader: (params) => {
    //     return (
    //       <>
    //         <Checkbox
    //           checked={isAllSelected}
    //           onChange={(e) => handleHeaderCheckboxChange(e)}
    //         />
    //         <strong>Select All</strong>
    //       </>
    //     );
    //   },
    // },
    { field: "cultivar", headerName: "Cultivar Name", flex: 1, minWidth: 200 },
    {
      field: "matric_id",
      headerName: "Mother Plant Metric ID",
      flex: 1,
      minWidth: 250,
    },
    { field: "tray_id", headerName: "Tray ID", flex: 1, minWidth: 130 },
    { field: "cluster_id", headerName: "Cluster ID", flex: 1, minWidth: 150 },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      minWidth: 130,
      renderCell: (params) => (
        <>
          <p>{params.value === true ? "Active" : "Inactive"}</p>
        </>
      ),
    },
    {
      field: "cuts",
      headerName: "Number of Cuts",
      flex: 1,
      minWidth: 110,
    },
    {
      field: "date",
      headerName: "Date",
      flex: 1,
      minWidth: 130,
      renderCell: (params) => (
        <>
          <div style={{ padding: "10px" }}>
            {params.row?.date
              ? dayjs(params.row.date).format("MM-DD-YYYY")
              : "-"}
          </div>
        </>
      ),
    },
  ];

  const isIdSelected = (id) => {
    return selectedId?.includes(id);
  };

  const toggleId = (id) => {
    setSelectedId((prev = []) => {
      if (prev.includes(id)) {
        const updatedSelectedIds = prev.filter((item) => item !== id);
        if (updatedSelectedIds.length < allIds) {
          setIsAllSelected(false);
        }
        return updatedSelectedIds;
      } else {
        const updatedSelectedIds = [...prev, id];
        if (updatedSelectedIds.length === allIds) {
          setIsAllSelected(true);
        }
        return updatedSelectedIds;
      }
    });
  };

  const handleHeaderCheckboxChange = (event) => {
    const isChecked = event.target.checked;
    if (isChecked) {
      const allIds = clusters?.map((row) => row.id); // Get all the IDs from the data
      setSelectedId(allIds); // Select all IDs
      setAllIds(allIds.length);
    } else {
      setSelectedId([]); // Deselect all
    }
    setIsAllSelected(isChecked);
  };

  const deleteSelectedCluster = async () => {
    if (selectedId?.length > 0) {
      try {
        const response = await httpService.post("motherplant/delete_clusters", {
          clusterIds: selectedId,
        });
        if (response?.success) {
          const messages = response.message;
          toast.success(messages, {
            position: "top-right",
          });
        } else {
          throw response;
        }
        setSearchData("");
        fetchClusters();
        setIsAllSelected();
        setSelectedId();
        setAllIds();
        setOpenDeleteModal(false);
      } catch (error) {
        setOpenDeleteModal(false);
        toast.error(error?.response?.data?.error, {
          position: "top-right",
        });
      }
    } else {
      toast.error("Please select atleast one Record", {
        position: "top-right",
      });
    }
  };

  const handleClose = () => {
    setOpenDeleteModal(false);
    fetchClusters();
  };

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleDateTimeModal = () => {
    setOpenDateModal(false);
  };

  const handleOpenDateTimeModal = () => {
    setOpenDateModal(true);
  };

  return (
    <div className="cluster">
      <div className="page-title">
        <div className="title-wrap">
          <h1>Cluster Detail</h1>
        </div>
        <div className="button-wrap">
          {/* <button
              type="submit"
              className="btn btn-primary"
              onClick={handleOpen}
            >
              <RxPlus /> Add Clone
            </button> */}
        </div>
      </div>
      <div className="table-filter-wrap d-flex justify-content-between pb-0">
        <div className="header_search-wrap">
          <div className="header_search_bar common_content d-flex">
            <div className="input-group input_group">
              <button className="btn search-btn search_btn">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  viewBox="0 0 21 21"
                  fill="none"
                >
                  <circle
                    cx="9.98856"
                    cy="9.98856"
                    r="8.98856"
                    stroke="#495057"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M16.2402 16.7071L19.7643 20.222"
                    stroke="#495057"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
              <input
                type="search"
                className="form-control form_control"
                placeholder="Search..."
                aria-label="Search"
                onChange={(e) => {
                  const value = e.target.value;
                  setSearchData(value);
                }}
              />
            </div>
          </div>
        </div>
        {/* <div className="d-flex flex-row"> */}
        <Button
          variant="outlined"
          color="primary"
          onClick={() => handleOpenDateTimeModal()}
          className="filters-btn"
          style={{ textTransform: "none" }}
        >
          <TbFilterEdit /> Filters
        </Button>
        {/* </div> */}
      </div>
      {/* <div className="table-filter-wrap d-flex justify-content-between pb-0 pt-2">
        <Button
          className="btn btn-delete"
          onClick={() => {
            if (selectedId?.length > 0) {
              setOpenDeleteModal(true);
            } else {
              toast.error("Please select atleast one department", {
                position: "top-right",
              });
            }
          }}
        >
          Delete
        </Button>
      </div> */}
      <div
        style={{
          height: `${clusters?.length > 0 ? "" : "200px"}`,
          width: "100%",
          marginTop: 24,
        }}
      >
        <DataGrid
          rows={clusters}
          columns={columns}
          loading={loading}
          initialState={{
            pagination: {
              rowCount: -1,
            },
          }}
          paginationMode="server"
          sortingMode="server"
          rowCount={rowCount}
          pageSizeOptions={[15, 50, 100]}
          paginationModel={{ pageSize: pageSize, page: page }}
          onPaginationModelChange={(event) => {
            setPage(event?.page);
            setPageSize(event?.pageSize);
          }}
          checkboxSelection={false}
          rowSelection={false}
          getRowHeight={() => "auto"}
          sx={{
            border: "1px solid #E0E0E0",
            [`& .${gridClasses.cell}`]: { py: 0.5 },
          }}
          autoHeight
          showCellVerticalBorder
          showColumnVerticalBorder
        />
      </div>
      <DeleteModal
        open={openDeleteModal}
        HandleClose={() => handleClose()}
        HandleDelete={() => {
          deleteSelectedCluster();
        }}
      />
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <MenuItem
          onClick={() => {
            setOpenDelete(true);
            setDeleteId(dataId);
            handleCloseMenu();
          }}
        >
          Delete
        </MenuItem>
        <MenuItem
          onClick={() => {
            setOpen(true);
            setIsAdd(false);
            setEditData(clusters.find((c) => c.id === dataId) || {});
            handleCloseMenu();
          }}
        >
          Edit
        </MenuItem>
      </Popover>
      {loading && <FullScreenLoader />}
      {/* Filter Modal Placeholder */}
      {openDateModal && (
        <DateTimeModal
          handleDateTimeModal={() => handleDateTimeModal()}
          setStartDate={(e) => setStartDate(e)}
          setEndDate={(e) => setEndDate(e)}
          open={openDateModal}
          fetchSchedule={() => {
            fetchClusters();
            const clusterDateFilter = {
              startDate: startDate,
              endDate: endDate,
              selectedRadio: selectedRadio,
            };
            localStorage.setItem(
              "clusterDateFilter",
              JSON.stringify(clusterDateFilter)
            );
          }}
          selectedRadio={selectedRadio}
          setSelectedRadio={(e) => setSelectedRadio(e)}
          startDate={startDate}
          endDate={endDate}
        />
      )}
    </div>
  );
};

export default Cluster;
